import { css, useTheme } from '@emotion/react'
import Image from './Image'
import React, { forwardRef } from 'react'
import { Card, Tab, TabPanel, MenuBody } from './'

const MegaMenu = forwardRef(
    ({ menuData, visible = false, onBlur, onFocus }, ref) => {
        const theme = useTheme()

        const style = css`
            position: absolute;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            top: 85px;
            left: 0;
            right: 0;
            z-index: 9;
            .tabs {
                flex-wrap: nowrap;
                .button-group {
                    margin-top: 1.5rem;
                    flex-direction: column;
                    border-left: 1px solid ${theme.colors?.lighterGray};
                    justify-content: flex-start;
                    align-items: center;
                    gap: 1rem;
                    width: 20%;
                    height: 100%;
                    button {
                        border-radius: ${theme.borderRadius?.default};
                        ${'' /* background-color: ${theme.colors.lightGray}; */}
                        border: 1px dashed ${theme.colors?.lightGray};
                        background-color: ${theme.colors?.lighterGray};
                        color: ${theme.colors?.lighter};
                        min-width: 8rem;
                        padding-top: 0.5rem;
                        padding-bottom: 0.5rem;
                        justify-content: center;
                        font-size: ${theme.fontSize?.sm};
                    }
                    .active-button {
                        background-color: ${theme.colors?.lighter};
                        color: ${theme.colors?.white};
                    }
                }
                .tab-panel {
                    ${'' /* width: 100%; */}
                    padding-right: 2rem;
                }
                .tab-content {
                    display: flex;
                }
            }
        `
        if (!visible) return null
        return (
            <div
                ref={ref}
                className="container"
                css={style}
                onMouseOver={onFocus}
                onMouseOut={onBlur}
            >
                <Card bordered shadow="xl" style="height: 100%;">
                    <Tab tabs={menuData}>
                        {menuData.map((item, idx) => (
                            <React.Fragment key={idx}>
                                <TabPanel style="width:80%;">
                                    <MenuBody items={item.children} />
                                </TabPanel>
                                {item.thumbnail && (
                                    <TabPanel>
                                        <Image
                                            noStyle
                                            src={item.thumbnail}
                                            width={200}
                                            height={120}
                                            alt="flag"
                                        />
                                    </TabPanel>
                                )}
                            </React.Fragment>
                        ))}
                    </Tab>
                </Card>
            </div>
        )
    }
)

export default MegaMenu
